"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.symbol.description.js");
var _react = _interopRequireDefault(require("react"));
var _SVBLabels = require("../../SVBLabels");
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const SVBAllApisCard = props => {
  const {
    title = '',
    description = '',
    label1 = 'Partner',
    label2 = '',
    label3 = '',
    version = 'v1.0',
    gradientClass = {
      private: 'all-api-private-gradient-color',
      partner: 'all-api-partner-gradient-color',
      public: 'all-api-public-gradient-color',
      domain_private: 'all-api-domain_private-gradient-color'
    },
    onClick
  } = props;
  let imageColor;
  const findLabelColor = label => {
    var _label;
    label = (_label = label) === null || _label === void 0 ? void 0 : _label.toLowerCase();
    if (label === 'public') {
      return 'violet';
    }
    if (label === 'private') {
      return 'green';
    }
    if (label === 'partner') {
      return 'red';
    }
    if (label === 'domain_private') {
      return 'lightgreen';
    }
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "all-api-containers all-width card w-0 p-0 m-0",
    onClick: onClick
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "bg-image all-api-bg-image ".concat(label1 ? gradientClass[label1.toLowerCase()] : 'all-api-public-gradient-color')
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "bg-image all-api-bg-image position-absolute top-0 w-100",
    style: imageColor
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "mask"
  }, /*#__PURE__*/_react.default.createElement("div", {
    type: "button",
    className: "d-flex flex-row justify-content-start align-items-center h-100 align-content-center align-self-center mt-2"
  }, /*#__PURE__*/_react.default.createElement("h1", {
    className: "text-white mb-0 sub-heading-large medium font-family-roboto"
  }, title)), label3 && /*#__PURE__*/_react.default.createElement("div", {
    className: "position-absolute end-0 bottom-0 pe-1 pb-1"
  }, /*#__PURE__*/_react.default.createElement(_SVBLabels.SVBLabels, {
    extraClasses: "d-flex svb-label_status_size-small rounded-pill px-2 align-items-center paragraph xx-small p-1 svb-tag_status-tag_success font-family-roboto svb-label_status_size-small svb-cards-status-label",
    showCircle: true,
    extraCircleClasses: true,
    labelType: 'status-labels-large',
    labelText: label3,
    subLabelType: 'status-label-active'
  }))))), /*#__PURE__*/_react.default.createElement("div", {
    className: "card-body d-flex flex-column h-25 p-2"
  }, /*#__PURE__*/_react.default.createElement("div", null, label1 && /*#__PURE__*/_react.default.createElement(_SVBLabels.SVBLabels, {
    labelType: "status-labels-small",
    labelText: label1,
    subLabelType: "status-label-deprecated",
    extraClasses: "me-1 text-white paragraph py-1 xx-small all-api-labels-container font-family-roboto all-api-bg-".concat(findLabelColor(label1))
  }), label2 && /*#__PURE__*/_react.default.createElement(_SVBLabels.SVBLabels, {
    labelType: "status-labels-small",
    labelText: label2,
    subLabelType: "status-label-deprecated",
    extraClasses: "d-inline-block paragraph  xx-small all-api-labels-container all-api-bg-primary font-family-roboto"
  })), /*#__PURE__*/_react.default.createElement("p", {
    className: "card-text paragraph small pt-2"
  }, description)), /*#__PURE__*/_react.default.createElement("div", {
    className: "card-footer text-muted text-start ps-2"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "paragraph xx-small font-family-roboto mb-0 all-api-version-color"
  }, "".concat(version))));
};
var _default = SVBAllApisCard;
exports.default = _default;
SVBAllApisCard.propTypes = {
  title: _propTypes.default.string,
  description: _propTypes.default.string,
  label1: _propTypes.default.string,
  label2: _propTypes.default.string,
  gradientArrClass: _propTypes.default.object,
  version: _propTypes.default.string
};